var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48597",
    "data-name": "Group 48597",
    transform: "translate(-1042 -668)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138032",
    "data-name": "Rectangle 138032",
    width: 24,
    height: 24,
    transform: "translate(1042 668)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48572",
    "data-name": "Group 48572",
    transform: "translate(-28.75 -11.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93208",
    "data-name": "Path 93208",
    d: "M16.75,9.78v5.97c0,4-1,5-5,5h-6c-4,0-5-1-5-5v-10c0-4,1-5,5-5h6c4,0,5,1,5,5Z",
    transform: "translate(1074 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    x1: 4,
    transform: "translate(1080.75 685.25)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(1081.2 695.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.8c7d0aff82fa73c742e7853fdd51bd20.svg";
export { ForwardRef as ReactComponent };